<template>
  <div class="word_cloud">
    <!-- 6. 流行的词云 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Region:</div>
            <el-select
              v-model="regionVal"
              clearable
              placeholder="Please choose"
              :popper-append-to-body="false"
              @change="changeArea"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <!-- <div class="dropdown report_year_drop">
          <div class="item_title">Select Region:</div>
          <button
            class="btn btn-default dropdown-toggle"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            Dropup
          </button>
          <ul class="dropdown-menu nano statenano" aria-labelledby="dropdownMenu2">
            <li class="nano-content nano-contents" v-for="item in options" :key="item.value">
              <a class="dropdown-item" href="#">{{item.value}}</a>
            </li>
            
          </ul>
        </div>-->
        <el-col :md="24">
          <div class="option region_det">
            <div class="item_title">Select Region:</div>
            <el-tag
              :key="tag.value"
              v-for="tag in dynamicTags"
              closable
              type="info"
              :disable-transitions="false"
              @click="getContent(tag)"
              @close="handleClose(tag)"
            >{{tag.value}}</el-tag>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="echarts_container home_echarts">
      <EWordCloud :wordData="wordData" :height="height" :isNodata="isNodata"></EWordCloud>
    </div>
  </div>
</template>

<script>
import titleTem from "../overseas_components/Title";
import EWordCloud from "./components/WordCloud";
import {
  homeWordPicture,
  listofCountries
} from "@/common/js/http/version3Api.js";
export default {
  name: "WordCloud",
  props: {
    country: {
      type: Array,
      default: () => []
    }
  },
  components: {
    titleTem,
    EWordCloud
  },
  data() {
    return {
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        }
      },
      passTitleData: {
        titleName: "Hot-word Cloud",
        commentTxt:
          "It shows hot content posted by the foreign media in different regions yesterday."
      },
      height: "350px",
      wordData: [],

      // 搜索条件
      regionVal: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      clickTruetag: [],
      countryArray: [],
      clickState: false,
      timer: null
    };
  },
  created() {
    this.setDate();
  },
  mounted() {
    // this.getlistofCountry();
    this.timer = setTimeout(() => {
      this.getWord();
    }, 500);
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    getStartDate() {
      this.getWord();
    },
    getEndDate() {
      this.getWord();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.clickTruetag.splice(this.clickTruetag.indexOf(tag.value), 1);
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";

      this.getWord();
    },
    getContent(val) {
      this.getWord();
    },
    //获取国家列表
    getlistofCountry() {
      this.options = this.country;
      this.options.map(item => {
        item.disabled = false;
        return item;
      });
    },
    getWord() {
      const time = new Date().getTime() - 24 * 60 * 60 * 1000;
      const yesday = new Date(time);
      const month = yesday.getMonth();
      const day = yesday.getDate();
      const resDate =
        yesday.getFullYear() +
        "-" +
        (yesday.getMonth() > 9
          ? yesday.getMonth() + 1
          : "0" + (yesday.getMonth() + 1)) +
        "-" +
        (yesday.getDate() > 9 ? yesday.getDate() : "0" + yesday.getDate());
      if (this.startDate == null) {
        this.startDate = "";
      }
      if (this.endDate == null) {
        this.endDate = "";
      }
      let data = {
        companyId: 1,
        regionalNames: this.clickTruetag,
        startTime: resDate,
        endTime: resDate
      };
      homeWordPicture(data).then(res => {
        this.wordData = res.result.series[0].data;
        if (this.wordData.length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //选择国家
    changeArea(val) {
      this.clickState = true;
      this.options.filter(item => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.clickTruetag.push(val);
      }
      this.getWord();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getWord();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getWord();
      }
    },
    country: {
      handler(newValue) {
        this.getlistofCountry();
      },
      deep: true
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
.title {
  margin-top: 20px;
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
.item_title {
  font-size: 14px;
  /* font-family: RCR; */
  color: #4e5671;
  display: inline-block;
  padding-right: 10px;
}
.condition_search >>> .dropup .dropdown-toggle::after {
  border-top: 0.3em solid !important;
  border-bottom: 0 !important;
}
.btn {
  border: 1px solid #dcdfe6 !important;
}
</style>
